import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";

import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { toast } from "react-toastify";
import { Box, IconButton, Snackbar, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { sellStatusApi } from "../../app/slices/kycUpdate/sellStatusSlice";

export default function SellStatus() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  useEffect(() => {
    dispatch(sellStatusApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse1 = useSelector(
    (state) => state.sellStatus.sellStatus.data
  );
  const stateLoading = useSelector((state) => state.sellStatus.loading);

  const sliceResponse = sliceResponse1?.map((item) => {
    const resultData = item.result?.data || {};

    return {
      id: item._id,
      customerRefNo: item.customerRefNo,
      partnerId: item.partner_id,
      partnerUsername: item.partner_username,
      status: item.status,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
      // Flattened from result.data
      merchantId: resultData.merchantId,
      quantity: resultData.quantity,
      totalAmount: resultData.totalAmount,
      preTaxAmount: resultData.preTaxAmount,
      metalType: resultData.metalType,
      rate: resultData.rate,
      uniqueId: resultData.uniqueId,
      transactionId: resultData.transactionId,
      userName: resultData.userName,
      merchantTransactionId: resultData.merchantTransactionId,
      mobileNumber: resultData.mobileNumber,
      goldBalance: resultData.goldBalance,
      silverBalance: resultData.silverBalance,
      bankAccountName: resultData.bankInfo?.accountName,
      bankAccountNumber: resultData.bankInfo?.accountNumber,
      ifscCode: resultData.bankInfo?.ifscCode,
      reason: item?.reason || 'N/A',


      // Add other fields if available
      // totalTaxAmount: resultData.totalTaxAmount || "",
      // invoiceNumber: resultData.invoiceNumber || "",
      // referenceId: resultData.referenceId || "",
    };
  });

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("status", { header: "Status", size: 30 }),
    columnHelper.accessor("reason", {
      header: "Reason",
      size: 30,
      Cell: ({ cell }) => <span>{cell.row.original?.reason || "N/A"}</span>,
    }),
    // columnHelper.accessor("reason", {
    //   header: "Reason",
    //   size: 30,
    //   // Temporarily remove or simplify:
    //   Cell: ({ cell }) => <span>{cell.getValue() || "N/A"}</div>,
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("userName", { header: "Name", size: 30 }),
            columnHelper.accessor("mobileNumber", { header: "Mobile No", size: 30 }),

    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.partnerId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.partnerId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.partnerId}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("partnerUsername", {
      header: "Partner Username",
      size: 30,
    }),

 columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => cell.row.original.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => cell.row.original.updatedAt?.split("T")[0],
    }),
    columnHelper.accessor("uniqueId", {
      header: "Unique ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.uniqueId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.uniqueId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.uniqueId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 50,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.transactionId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.transactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.transactionId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Txn ID",
      size: 50,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original.merchantTransactionId
          );
          toast?.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),
    

    // columnHelper.accessor("merchantId", { header: "Merchant ID", size: 30 }),
    columnHelper.accessor("quantity", { header: "Quantity", size: 30 }),
    columnHelper.accessor("totalAmount", { header: "Total Amount", size: 30 }),
    columnHelper.accessor("preTaxAmount", {
      header: "Pre-Tax Amount",
      size: 30,
    }),
    columnHelper.accessor("metalType", { header: "Metal Type", size: 30 }),
    columnHelper.accessor("rate", { header: "Rate", size: 30 }),
    columnHelper.accessor("goldBalance", { header: "Gold Balance", size: 30 }),
    columnHelper.accessor("silverBalance", {
      header: "Silver Balance",
      size: 30,
    }),
    columnHelper.accessor("bankAccountName", {
      header: "Account Name",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.bankAccountName);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.bankAccountName}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.bankAccountName}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("bankAccountNumber", {
      header: "Account No.",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.bankAccountNumber);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.bankAccountNumber}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.bankAccountNumber}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("ifscCode", {
      header: "IFSC Code",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.ifscCode);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.ifscCode}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.ifscCode}
            </span>
          </Tooltip>
        );
      },
    }),
    // columnHelper.accessor("totalTaxAmount", { header: "Total Tax", size: 30 }),
    // columnHelper.accessor("invoiceNumber", { header: "Invoice No", size: 30 }),
    // columnHelper.accessor("referenceId", { header: "Reference ID", size: 30 }),
   
  ];

  return (
    <>
     {/*  */}
      <DateSearchComponent onSearch={handleSearch} />
      <Box mt={2}>
        <CustomTable
          columns={columns}
          data={sliceResponse}
          loading={stateLoading}
          permissionKey="kycUpdate"
        />
      </Box>
    </>
  );
}
